'use client';
import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { lazy as N, Suspense as b } from "react";
import { Button as A } from "@gs-ux-uitoolkit-react/button";
import { ForgeIcon as C } from "@forge-ui-components/atoms";
import { StyleSheet as x, useStyleSheet as B } from "@gs-ux-uitoolkit-react/style";
import { errorAlert as q, buttonClasses as E } from "./index.es8.js";
import { LABELS as n } from "./index.es6.js";
import { useFollow as I } from "./index.es9.js";
import { isAlertingSuspended as L } from "./index.es3.js";
const V = N(() => import("./index.es7.js")), H = ({ followItem: i, targetId: t, withDropdown: s, isError: a }) => {
  var r;
  const {
    isError: d,
    interest: e,
    isFollowLoading: m,
    distributionChannels: c,
    handleFollow: u,
    handleUnFollow: p,
    onFrequencyChange: f,
    showBellIcon: h,
    dropdownVisible: w,
    hideMenu: g,
    toggleAlerts: F
  } = I(i, s), S = L(), y = new x("button-override", {
    root: { display: "flex !important" }
  }), v = B(y, null);
  return /* @__PURE__ */ l("div", { className: "relative", children: [
    d || a ? /* @__PURE__ */ o("div", { role: "alert", className: q, children: "Something went wrong" }) : null,
    /* @__PURE__ */ l(
      A,
      {
        "data-testid": "follow-button",
        id: t,
        classes: { root: v.root },
        className: E(e),
        onClick: m ? void 0 : u,
        actionType: "primary",
        emphasis: "bold",
        children: [
          e.followActive ? n.following : n.follow,
          h && /* @__PURE__ */ o(
            C,
            {
              icon: "notifications",
              "data-testid": "bell-icon",
              pxSize: 16,
              color: "#FFFFFF",
              classNames: "ml-1 !p-0"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o(b, { children: /* @__PURE__ */ o(
      V,
      {
        target: t,
        visible: w,
        hideMenu: g,
        customInterest: e.customInterest,
        tagName: e.tag && e.tag.tagName || e.interestName || void 0,
        interestName: e.interestName,
        distributionChannels: c,
        isSuspended: S,
        highVolume: e.highVolume,
        onFrequencyChange: f,
        selectedFrequency: ((r = e.deliveryPreference) == null ? void 0 : r.frequency) || e.frequency,
        onUnfollowButtonClick: p,
        includeAlerts: e.includeAlerts || [],
        toggleAlerts: F
      }
    ) })
  ] });
};
export {
  H as default
};
//# sourceMappingURL=index.es5.js.map
